export class CustomerInfoModel {
  public currencyCode: string;

  constructor(params: CustomerInfoModel) {
    this.currencyCode = params.currencyCode;
  }

  public static fromCartV1(currencyCode: string) {
    return new CustomerInfoModel({
      currencyCode,
    });
  }
}
